import { Record } from "immutable";

export type SectionStatType = {
  bestScore?: number;
};

export const defaultSectionStat: SectionStatType = {
  bestScore: undefined
};

export default class AverageStats extends Record(defaultSectionStat) {}
